export enum SortType {
    Defualt = 0,
    Asc = 1,
    Desc = 2,
}